import Box from '@mui/material/Box';
import React from 'react';

interface Props {
  className?: string;
  width?: string | number;
  height?: string | number;
  overlay?: boolean;
  relative?: boolean;
  children: React.ReactNode;
}

const Hero: React.FC<Props> = (props) => {
  const {
    overlay,
    className,
    children,
    relative,
    width = '100%',
    height = '100%',
  } = props;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={className}
      sx={{
        width,
        height,
        position: relative ? 'relative' : 'absolute',
        top: 0,
        left: 0,
        ...(overlay && { backgroundColor: 'background.default' }),
      }}
    >
      <Box>{children}</Box>
    </Box>
  );
};

export default Hero;
export { Hero };
